import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
// Fonts are bundled (no third-party font requests, and they work offline)
import '@fontsource/mukta/400.css'
import '@fontsource/mukta/500.css'
import '@fontsource/mukta/700.css'
import '@fontsource/mukta/800.css'
import '@fontsource/tiro-devanagari-hindi/400.css'
import './styles.css'
import './theme-3d.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>
)

// Register service worker for offline support and PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((registration) => {
      if (!registration) return // some browsers/policies block service workers
      // When a new SW is found, tell it to take over immediately
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (!newWorker) return
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New content available - reload to apply update
            newWorker.postMessage({ type: 'SKIP_WAITING' })
            window.location.reload()
          }
        })
      })
    })

    // When SW controller changes (i.e., new SW took over), reload page
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true
        window.location.reload()
      }
    })
  })
}
